export enum DatafileActions {
  GET_ITEMS = 'get_files',
  SET_ITEMS = 'set_files',
  UPLOAD_FILES = 'upload_files'
}